<template>
  <v-dialog v-model="dialog" persistent max-width="600px">
    <template #activator="{ on, attrs }">
      <v-btn
        color="primary"
        dark
        v-bind="attrs"
        v-on="on"
      >
        <slot />
      </v-btn>
    </template>
    <form @submit.prevent="save">
      <v-card>
        <v-toolbar flat>
          <v-toolbar-title>Logout Other Browser Sessions</v-toolbar-title>
          <v-spacer />
          <v-btn icon @click="cancel">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          Please enter your password to confirm you would like to logout of your other browser sessions across all of your devices.
          <v-text-field
            v-model="form.password"
            label="Password"
            outlined
            :class="{ 'is-invalid': form.errors.password }"
            class="form-control"
            name="password"
            :error="form.errors.password"
            :error-messages="form.errors.password"
            :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
            :type="showPassword ? 'text' : 'password'"
            @click:append="showPassword = !showPassword"
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="primary" text @click="cancel">
            Cancel
          </v-btn>
          <v-btn :loading="form.processing" color="primary" type="submit">
            Logout Other Browser Sessions
          </v-btn>
        </v-card-actions>
      </v-card>
    </form>
  </v-dialog>
</template>

<script>
export default {
   components: {
      //
   },

   props: {

   },

   data () {
      return {
         dialog: false,
         showPassword: false,
         form: this.$inertia.form({
            password: '',
         })
      }
   },

   methods: {
      cancel () {
         this.dialog = false
      },

      save () {
         this.form.delete(this.route('other-browser-sessions.destroy'), {
            preserveScroll: true,
            onSuccess: () => {
               if (!this.form.errors) {
                  this.dialog = false
               }
            }
         })
      },
   }
}
</script>
